import apiInstance from "../Api/ApiInstance";

export async function HelpersByCode(code) {
  return await apiInstance.get(`api/nexus-main/helpers/code/${code}`);
}
